export const GoogleIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 186.7 190.5" {...props}>
    <path
      fill="#4285f4"
      d="M95.3 78v36.8h51.2a44 44 0 0 1-19.1 28.7l30.9 24a93 93 0 0 0 28.4-70c0-6.8-.6-13.3-1.7-19.6z"
    />
    <path
      fill="#34a853"
      d="m41.9 113.4-7 5.3L10.2 138a95.2 95.2 0 0 0 85 52.6 91 91 0 0 0 63-23l-30.8-24a56.9 56.9 0 0 1-85.5-30z"
    />
    <path fill="#fbbc05" d="M10.2 52.6a94 94 0 0 0 0 85.3L42 113.3a57 57 0 0 1 0-36.1z" />
    <path
      fill="#ea4335"
      d="M95.3 38a52 52 0 0 1 36.4 14L159 25A91.4 91.4 0 0 0 95.2 0a95 95 0 0 0-85 52.6L42 77.2a56.9 56.9 0 0 1 53.4-39.3z"
    />
  </svg>
);
